// @ts-nocheck
import { useTranslation } from 'react-i18next'
import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'

import AddEditForm from './AddEditForm/AddEditForm'
import addEditFragment from './fragments/addEditFragment'

const AddGroup = () => {
    const { loading, error, data } = useQuery<any>(GET_SITE_INFO_FOR_GROUP, {
        fetchPolicy: 'network-only',
    })

    const { t } = useTranslation()

    if (error) {
        console.error(error)
    }
    if (loading || error || !data) {
        return null
    }

    return (
        <AddEditForm
            title={t('entity-group.create')}
            viewer={data.viewer}
            site={data.site}
        />
    )
}

const GET_SITE_INFO_FOR_GROUP = gql`
    query GetSiteInfoForGroup {
        ${addEditFragment}
    }
`

export default AddGroup
